import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { LookupService } from 'src/app/Services/Common/lookup.service';
import { HrService } from 'src/app/services/hr/hr.service';
import * as moment from 'moment';

@Component({
  selector: 'app-monthly-attendance-staff-print',
  templateUrl: './monthly-attendance-staff-print.component.html',
  styleUrls: ['./monthly-attendance-staff-print.component.css']
})
export class MonthlyAttendanceStaffPrintComponent implements OnInit {

  DailyAttendanceModel = {
    EmployeeCategoryID: 0,
    PrimaryDepartmentID: 0,
    DesignationID: 0,
    StaffIdentity: '',
    StartDate: '',
    EndDate: '',
  }

  OrganizationDetails: any;
  StaffMonthlyAttendanceList: any;
  MonthlyAttendance = [];
  CurrentStatusHeader = [];
  Integer: any;
  decimal: any;
  itemsPerPage = 10;
  pagedItems = [];

  constructor(public globalHelper: GlobalHelper, private activatedRoute: ActivatedRoute,
    private payrollService: HrService, private lookupService: LookupService,
    private spinnerService: Ng4LoadingSpinnerService) {
    this.activatedRoute.queryParams.subscribe(params => {
      this.DailyAttendanceModel.EmployeeCategoryID = params['EmployeeCategoryID'];
      this.DailyAttendanceModel.PrimaryDepartmentID = params['PrimaryDepartmentID'];
      this.DailyAttendanceModel.DesignationID = params['DesignationID'];
      this.DailyAttendanceModel.StaffIdentity = params['StaffIdentity'];
      this.DailyAttendanceModel.StartDate = params['StartDate'];
      this.DailyAttendanceModel.EndDate = params['EndDate'];

      this.GetStaffMonthlyAttendance();
    });

  }

  GetStaffMonthlyAttendance() {
    this.spinnerService.show();
    this.DailyAttendanceModel.StartDate = this.DailyAttendanceModel.StartDate != null && this.DailyAttendanceModel.StartDate != '' ? moment(this.DailyAttendanceModel.StartDate).format('DD-MMM-YYYY') : '';
    this.DailyAttendanceModel.EndDate = this.DailyAttendanceModel.EndDate != null && this.DailyAttendanceModel.EndDate != '' ? moment(this.DailyAttendanceModel.EndDate).format('DD-MMM-YYYY') : '';
    this.payrollService.GetStaffMonthlyAttendance(JSON.stringify(this.DailyAttendanceModel)).subscribe((data: any) => {
      this.OrganizationDetails = data.BranchDetails;   
      if (data.StaffMonthlyAttendanceList != null) {
        this.StaffMonthlyAttendanceList = data.StaffMonthlyAttendanceList;
        this.MonthlyAttendance = this.StaffMonthlyAttendanceList[0].DayList;
        this.CurrentStatusHeader = data.CurrentStatusHeader;

      }
      this.spinnerService.hide()
      setTimeout(function () {
        window.print();
      }, 3000);


    });

  };



  search(itemlist) {

    for (var i = 0; i < itemlist.length; i++) {
      if (i % this.itemsPerPage === 0) {
        this.pagedItems[Math.floor(i / this.itemsPerPage)] = [itemlist[i]];
      } else {
        this.pagedItems[Math.floor(i / this.itemsPerPage)].push(itemlist[i]);
      }
    }

  }

  ngOnInit() {
    this.GetLeaveType();
  }
  LeaveTypeList = [];
  GetLeaveType() {
    this.lookupService.GetLookupsList('LeaveType', '').subscribe((data: any) => {
      this.LeaveTypeList = data.LookupItems;
      this.LeaveTypeList.splice(0, 1);
    });
  };


}


